<div class="slider-container" *ngIf="data && data.slider">
  <div class="banner-wrap">
    <div class="item">
      <img
        id="slider-img"
        srcset=""
        src="{{ env.UPLOADS_IMGIX_URL }}dynamic/homepage/{{ data.slider.image_url }}.{{ data.slider.extension }}"
        alt="{{ data.slider.image_url }}.{{ data.slider.extension }}"
        class="img-responsive w-100 forOther"
        fetchpriority="high"
      />
      <div class="container">
        <div id="home-slider-title-div" class="home-slider-title-div">
          <div id="the-vintage-bar-title" class="the-vintage-bar-title">THE VINTAGE BAR</div>

          <h1 [innerHTML]="data.slider.title"></h1>

          <div id="shop-btn" class="shop-btn">
            <a href="{{ data.slider.link }}">{{ data.slider.button }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ** Disable we love ** -->
<!-- <div id="we-love-box" class="products-box" *ngIf="weLoveShowcaseData?.items?.length > 0">
  <div id="we-love-header" class="container box-header">
    <span id="we-love-title" class="title">
      {{ 'We love' | translate }}
    </span>

    <a id="see-all-link" class="link primary see-all-link" routerLink="/discover/we-love">
      {{ 'See all' | translate }}
    </a>
  </div>

  <div class="showcase-container container">
    <tvb-showcase [data]="weLoveShowcaseData">
      <ng-template let-item #weLove>
        <tvb-product-spotlight
          [product]="item"
          [showSaleBadge]="false"
          [showWeLoveTag]="true"
          [currencyCode]="weLoveShowcaseData?.currencyCode"
        ></tvb-product-spotlight>
      </ng-template>
    </tvb-showcase>
  </div>
</div> -->

<div class="container small-container" *ngIf="data?.home">
  <div class="row">
    <app-intro-section [sectionInfo]="data.home"></app-intro-section>
  </div>
</div>

<div id="campaigns-box" class="container" *ngIf="campaignsShowcaseData?.items?.length > 0">
  <tvb-showcase [data]="campaignsShowcaseData">
    <ng-template let-item #campaigns>
      <tvb-campaign-card [campaign]="item"></tvb-campaign-card>
    </ng-template>
  </tvb-showcase>
</div>

<div id="recommend-box" class="products-box" *ngIf="recommendShowcaseData?.items?.length > 0">
  <div id="recommend-header" class="container box-header">
    <span id="recommend-title" class="title">
      {{ 'Recommended for you' | translate }}
    </span>

    <a class="link primary see-all-link" routerLink="/shop">
      {{ 'See all' | translate }}
    </a>
  </div>

  <div class="showcase-container container">
    <tvb-showcase [data]="recommendShowcaseData">
      <ng-template let-item #recommend>
        <tvb-product-spotlight
          [product]="item"
          [showSaleBadge]="false"
          [showWeLoveTag]="true"
          [currencyCode]="recommendShowcaseData?.currencyCode"
        ></tvb-product-spotlight>
      </ng-template>
    </tvb-showcase>
  </div>
</div>

<div class="container mentioned-in-div">
  <div class="mentioned-in-title">{{ 'Mentioned In' | translate }}</div>
  <div class="mentioned-in-images">
    <img
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [lazyLoad]="env.IMGIX_UPLOADS_URL + 'static/home/elle.svg'"
      alt="elle logo"
    />
    <img
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [lazyLoad]="env.IMGIX_UPLOADS_URL + 'static/home/vogue.svg'"
      alt="vogue logo"
    />
    <img
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [lazyLoad]="env.IMGIX_UPLOADS_URL + 'static/home/vogue-scandinavia.svg'"
      alt="vogue scandinavia logo"
    />
    <img
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [lazyLoad]="env.IMGIX_UPLOADS_URL + 'static/home/hypebae.svg'"
      alt="hypebae logo"
    />
    <img
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [lazyLoad]="env.IMGIX_UPLOADS_URL + 'static/home/wwd.svg'"
      alt="wwd logo"
    />
  </div>
</div>

<ng-container *ngIf="articles">
  <tvb-popular-articles [articles]="articles"></tvb-popular-articles>
</ng-container>

<div class="container box-for-your-budget" *ngIf="data?.home">
  <tvb-for-your-budget></tvb-for-your-budget>
</div>

<!-- **Disable New-Arrivals** -->
<!-- <div class="container small-container" *ngIf="data?.home">
  <div class="row">
    <tvb-new-arrivals [numOfProducts]="numOfProducts"></tvb-new-arrivals>
  </div>
</div> -->

<div class="box-usp" *ngIf="data?.home">
  <tvb-unique-selling-point></tvb-unique-selling-point>
</div>
